module.exports = __webpack_public_path__ + "img/kindergarten.6fdb1237.svg";